import React from "react";
import { Topbar } from "@components";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import {
	AppleFilled,
	FacebookFilled,
	PlayStoreFilled,
	ViberFilled,
	YoutubeFilled,
	ApkFilled,
	TelegramFilled,
} from "@assets";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
	TopImg,
	RootContainer,
	Title,
	Wrapper,
	SimpleLink,
	DownloadWrapper,
	SocialWrapper,
	Desc,
} from "./AppDownload.style";
import { Flex } from "antd";


const AppDownload = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { social_links } = useSelector((state) => state.app.settings);

	const goBack = () => {
		navigate(`/${PUBLIC_ROUTE.HOME}`);
	};

	const callHandler = (url) => {
		if (window.flutter_inappwebview?.callHandler) {
			window.flutter_inappwebview.callHandler("onEvent", url);
		}
	}

	const Link = ({ url, children, ...props }) => (
		<SimpleLink
			href={url}
			target="_blank"
			rel="noreferrer noopen"
			{...props}
		>
			{children}
		</SimpleLink>
	);

	return (
		<>
			<Topbar title={t("home.appDownloadTitle")} goBack={goBack} />
			<RootContainer>
				<TopImg />

				<Wrapper>
					<Title>{t("home.appDownloadSubTitle2", {
						appName: t("common.appName")
					})}</Title>

					<Desc> {t("home.appDownloadDesc", {
						appName: t("common.appName")
					})} </Desc>
					<DownloadWrapper>
						<Flex
							justify="between"
							style={{ width: "100%" }}
							gap={16}
						>
							<Link url={social_links?.app_store_link}>
								<AppleFilled />
							</Link>
							<Link url={social_links?.play_store_link} onClick={() => callHandler(social_links?.play_store_link)}>
								<PlayStoreFilled />
							</Link>
						</Flex>
						<Flex>
							<Link url={social_links?.download_link} onClick={() => callHandler(social_links?.download_link)}>
								<ApkFilled />
							</Link>
						</Flex>
					</DownloadWrapper>
				</Wrapper>

				<Wrapper>
					<Title
						style={{ fontSize: 16 }}
					>{t("home.appDownloadSubTitle1")}</Title>
					<SocialWrapper>
						<Link url={social_links?.fb_link}>
							<FacebookFilled />
						</Link>
						<Link url={social_links?.viber_link}>
							<ViberFilled />
						</Link>
						<Link url={social_links?.telegram_link}>
							<TelegramFilled />
						</Link>
						<Link url={social_links?.youtube_link}>
							<YoutubeFilled />
						</Link>
					</SocialWrapper>
				</Wrapper>
			</RootContainer>
		</>
	);
};

export default AppDownload;
